//import Uiconstants from "../../lib/UIconstants"
import CloseController from '../../controllers/CloseController';
import BonusBuyPageController from '../../controllers/bonus/BonusBuyPageController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusBuyGridView } from './BonusBuyGridView';

export const BonusPageView = {
	name: COMPONENTS.BONUS_BUY_PAGE,
	child: true,
	zIndex: 2,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true,
				holder: 'bonus_buy_holder'
			}
		},
		{
			Controller: BonusBuyPageController,
			name: 'BonusBuyPageController',
			config: {
				items: [
					'BONUS_BUY_DIALOG_FREESPIN_COST',
					'BONUS_BUY_DIALOG_FREESPIN_AMOUNT'
				],
				holder: 'bonus_buy_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'BonusBuyPageGridController',
			config: BonusBuyGridView
		}
	],
	components: [
		{
			name: 'bonus_buy_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'dialog_main_bg',
					position: { x: 0, y: 0 }
				},
				{
					name: 'bg-border',
					type: 'Sprite',
					img: 'sm_modal_frame',
					position: { x: -20, y: -20 }
				},
				{
					name: 'header',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_HEADER',
					position: { x: 587 / 2, y: 40 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_DESCRIPTION_0',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_DESCRIPTION_0',
					position: { x: 587 / 2, y: 140 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_FREESPIN_AMOUNT',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_FREESPIN_AMOUNT',
					position: { x: 100, y: 183 }
				},
				{
					name: 'BONUS_BUY_DIALOG_DESCRIPTION_1',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_DESCRIPTION_1',
					position: { x: 587 / 2 + 15, y: 190 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_FREESPIN_COST',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_FREESPIN_COST',
					position: { x: 587 / 2, y: 240 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'dialog_no_btn',
					position: { x: 215, y: 395 }
				},
				{
					name: 'yes_btn_wrapper',
					type: 'Sprite',
					components: [
						{
							name: 'yes_btn',
							type: 'ActionButton',
							bg: 'dialog_yes_btn',
							position: { x: 375, y: 395 }
						}
					]
				}
			]
		}
	]
};
